
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/rules",
      function () {
        return require("private-next-pages/[locale]/rules/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/rules"])
      });
    }
  